<script setup>
import SearchIcon from "assets/svg/search/SearchIcon.vue";
import { useSearchAction } from "~/composable/useSearchAction.js";
const { handleSubmit } = useSearchAction()
const searchFormRef = ref(null)
import { useHeaderStore } from "~/stores/headerState.js";
import { storeToRefs } from 'pinia'
const img = useImage()
const backgroundStyles = computed(() => {
  const imgUrl = img('/images/searchBanner.png', { format: 'webp' })
  return { backgroundImage: `url('${imgUrl}')` }
})

// 모바일 헤더를 처리하는 전역 상태 관리
const store = useHeaderStore();
const { searchTitleType } = storeToRefs(store)

function triggerSubmit() {
  if (searchFormRef.value) {
    searchFormRef.value.dispatchEvent(new Event('submit', { cancelable: true }));
  }
}
</script>

<template>
  <section :style="backgroundStyles">
    <div>
      <h1>{{ searchTitleType }} 간편조회</h1>
      <p>
        사업자 등록 번호/법인등록번호/상호명 으로 <br />
        간편하게 회사의 정보를 찾아보세요!
      </p>
      <form ref="searchFormRef" @submit="handleSubmit">
        <input name="s" type="text" placeholder="사업자 등록 번호/법인등록번호/상호명 입력" autocomplete="off" />
        <SearchIcon class="search_icon" @click="triggerSubmit" />
      </form>
    </div>
  </section>
</template>

<style scoped lang="scss">
section {
  display: flex;
  justify-content: center;
  align-items: center;

  background-size: 1920px;
  background-position: top;
  background-repeat: no-repeat;

  height: 450px;
  background-color: #101010;
}

section > div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  color: #FFF;
  & > h1 {
    font-size: 48px;
    font-weight: 600;
    margin: 0;
  }
  & > p {
    margin: 17px 0 32px 0;
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.5;
  }

  & > form {
    position: relative;
    & > .search_icon {
      width: 24px;
      height: 24px;
      position: absolute;
      color: #C8C8C8;
      top: 50%;
      right: 2%;
      transform: translate(-50%, -50%);
      cursor: pointer;
    }
  }

  & > form > input {
    width: 450px;
    height: 56px;
    padding: 16px 52px 16px 16px;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 500;
    color: #000;
    border: 1px solid #C8C8C8;
    border-radius: 8px;
    &::placeholder {
      color: #C8C8C8;
      opacity: 1; /* Firefox */
    }
    &::-ms-input-placeholder { /* Edge 12 -18 */
      color: #C8C8C8;
    }
  }
}

@media (max-width: 960px) {
  section {
    align-items: center;
    height: 293px;
    background-size: 100%;
  }

  section > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    & > h1 {
      font-size: 30px;
      text-align: center;
    }
    & > p {
      margin: 16px 0 32px 0;
      font-size: 14px;
    }

    & > form {
      width: 280px;
      position: relative;

      & > .search_icon {
        width: 24px;
        height: 24px;
        position: absolute;
        color: #C8C8C8;
        right: 0;
      }
    }

    & > form > input {
      width: 280px;
      height: 40px;
      padding: 12px 51px 12.5px 12px ;
      box-sizing: border-box;
      font-size: 12px;
    }
  }
}
</style>